import { HpControlValueTypes } from '../../../types';
import { HpTextInputControlProps, TextInputControl } from './textInputControl';

export function PromoCodeInputControl(props: HpTextInputControlProps): JSX.Element {
  return TextInputControl({
    ...props,
    errorPosition: 'bottom',
    formatter: {
      undo: (val: HpControlValueTypes): string => {
        return (val as string).toUpperCase().replace(/ /g, '');
      }
    }
  });
}
